if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId    = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const swiper      = this.querySelector('swiper-slider');

        if (!activeMedia) return;

        if (swiper) {
          if (!swiper.slider && !swiper.initialized) {
            setTimeout(() => this.showActiveMedia(), 100);
            return;
          }

          // ── Only consider visible slides when calculating index ───────────
          // Hidden meta slides (display:none) must be excluded, otherwise the
          // index count is wrong after syncModalSwiper toggled visibility.
          const slides = Array.from(swiper.querySelectorAll('[data-swiper-slide]')).filter(
            (s) => s.style.display !== 'none'
          );

          let targetIndex = -1;

          for (let i = 0; i < slides.length; i++) {
            const slide = slides[i];

            if (
              slide.querySelector(`[data-media-id="${mediaId}"]`) ||
              slide.getAttribute('data-media-id') === mediaId
            ) {
              // Prefer data-swiper-slide-index if present and valid,
              // otherwise fall back to visible DOM position
              const attr = slide.getAttribute('data-swiper-slide-index');
              targetIndex = attr !== null && !isNaN(parseInt(attr, 10))
                ? parseInt(attr, 10)
                : i;
              break;
            }
          }

          if (targetIndex > -1) {
            // ── Use slideToLoop for reliability after loopDestroy/loopCreate ─
            swiper.slider
              ? swiper.slider.slideToLoop(targetIndex, 0)
              : swiper.performSlideToIndex(targetIndex + 1, 0);

            const freshActiveMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
            if (!freshActiveMedia) return;

            const activeMediaTemplate = freshActiveMedia.querySelector('template');
            const activeMediaContent  = activeMediaTemplate ? activeMediaTemplate.content : null;

            if (
              freshActiveMedia.nodeName === 'DEFERRED-MEDIA' &&
              activeMediaContent?.querySelector('.js-youtube')
            ) {
              freshActiveMedia.loadContent();
            }
            return;
          }
        }
      }
    }
  );
}